class BeforeAndAfterCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 20,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2,
              spacing: 35,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md +
            1}px)`]: {
            disabled: true,
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useDots(this.els?.dot?.elements),
      ],
      this.externalEls.slider.elements.forEach(el => {
        el.addEventListener(
          'mousedown',
          e => {
            e.stopPropagation()
          },
          { capture: true },
        )
      }),
      this.externalEls.slider.elements.forEach(el => {
        el.addEventListener(
          'touchstart',
          e => {
            e.stopPropagation()
          },
          { capture: true },
        )
      }),
    )
  }
}

if (!customElements.get('before-and-after-carousel')) {
  customElements.define('before-and-after-carousel', BeforeAndAfterCarousel)
}
